import styled from '@emotion/styled';
import React from 'react';
import tw from 'twin.macro';

interface CardSectionProps {
  children: React.ReactNode;
  divider?: boolean;
  moreActions?: React.ReactNode;
  padContent?: boolean;
  title?: string | React.ReactNode;
}

interface ContainerProps {
  divider: boolean;
}

interface ContentContainerProps {
  padContent: boolean;
}

const Container = styled.div<ContainerProps>`
  ${tw`w-full p-5`};
  ${(props) => props.divider && tw`border-b border-divider`}
`;

const ContentContainer = styled.div<ContentContainerProps>`
  ${(props) => props.padContent && tw`pb-4`}
`;

const Header = styled.div`
  ${tw`flex justify-between mb-4`};
`;

export const CardSection = (props: CardSectionProps) => {
  const {
    children,
    divider = false,
    moreActions,
    padContent = false,
    title,
  } = props;

  return (
    <Container divider={divider}>
      {title && (
        <Header>
          <div className="pr-8 text-base font-semibold text-t-base-light">
            {title}
          </div>
          {moreActions && (
            <div className="relative w-10">
              <div className="absolute right-0 top-">{moreActions}</div>
            </div>
          )}
        </Header>
      )}
      <ContentContainer padContent={padContent}>{children}</ContentContainer>
    </Container>
  );
};
